import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'p8-layout-settings-footer',
  templateUrl: './settings-footer.component.html',
  styleUrls: ['./settings-footer.component.scss']
})
export class SettingsLayoutFooterComponent implements OnInit {
  @Input() flexLayoutAlign: string = 'start';

  constructor() { }

  ngOnInit() {
  }

}
